import React from 'react';
import { runtime } from '../../common';
import { Scrollbar } from '../Base';

export default class Table extends React.Component {

  constructor(props) {
    super(props);
  }

  header(columns){
    let end = columns.length-1;
    const pxClassName= runtime.mobile ? "px-1" : "px-3";
    return (
      <div className="row no-gutters c-l w-100">
        {
          columns.map(({width,align,label},index)=>{
            return (
              <div key={index} className={`col-${width} text-${align} c-bg-body py-2 ${pxClassName} ${index<end?'c-lr':''}`}>
                {label}
              </div>
            );
          })
        }
      </div>
    );
  }

  body(columns,{rows}){
    let end = columns.length-1;
    let rowsEnd = rows.length-1;
    const pxClassName= runtime.mobile ? "px-1" : "px-3";
    return rows.map((row,rowIndex)=>{
      return (
      <div key={rowIndex} className={`row no-gutters ${rowIndex<rowsEnd?'c-lb':''} w-100`}>
        {
          columns.map(({width,align,label,field,component},index)=>{
            return (
              <div key={index} className={`col-${width} justify-content-${align} d-flex align-items-center py-2 ${pxClassName} ${index<end?'c-lr':''}`}>
                {this.renderColumn(row,rowIndex,{field,component})}
              </div>
            );
          })
        }
      </div>
      )
    });
  }

  renderColumn(row,rowIndex,{field,component}){
    return component ? component(row, rowIndex) : row[field];
  }

  footer({left,right}){
    return (
      <div className="row no-gutters c-ll c-lr c-lb">
        <div className={`col-6 text-left py-2 px-3`}>
          {left}
        </div>
        <div className={`col-6 text-right py-2 px-3`}>
          {right}
        </div>
      </div>
    );
  }


  scrollable(){
    let {columns,data,scrollable} = this.props;
    if(scrollable === false) return;
    return (
      <Scrollbar autoHide={false} className={`${scrollable?`d-${scrollable}-block`:''}`}>
        {this.body(columns,data)}
      </Scrollbar>
    );
  }

  noscrollable(){
    let {columns,data,scrollable} = this.props;
    if(!scrollable && scrollable !== false) return;//没有设置scrollable在什么时候有效，那就是永久有效，不会显示非滚动条视图
    return (
      <div className={`${scrollable?`d-${scrollable}-none`:''}`}>
        {this.body(columns,data)}
      </div>
    );
  }
  
  render() {
    let {columns,data,footer,className} = this.props;
    data=data||{rows:[]};
    return (
      <div className={`d-flex flex-column c-text-light-dark c-text-s1 ${className}`}>
        <div className="d-flex w-100">
        {this.header(columns)}
        </div>
        <div className="d-flex flex-column c-flex-1 c-ll c-lr c-lb">
          {this.scrollable()}
          {this.noscrollable()}
        </div>
        <div className="d-flex w-100">
        {footer?this.footer(footer):null}
        </div>
      </div>
    )
  }
}